import gql from 'graphql-tag';

export const DELETE_ROOM_MUTATION = gql`
    mutation DeleteRoomMutation($roomId: UUID!) {
        deleteRoom(roomId: $roomId)
    }
`